import { Col, Container, Row, Button } from 'react-bootstrap';
import { AuthBtnsStyle, BtnClsNames } from "../../config/btn_config"
import { useNavigate } from "react-router-dom";

export const AuthPage = () => {

    const navigate = useNavigate();

    return (
        <Container
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "100vh" }}
        >
            <Row className="w-100">
                <Col xs={12} sm={10} md={6} lg={4} className="mx-auto">
                    <Row className="mb-3">
                        <Col>
                            <Button
                                id="login"
                                className={BtnClsNames}
                                style={AuthBtnsStyle.login}
                                onClick={() => navigate('/auth/login')}
                            >
                                Login
                            </Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Button
                                id="sign_up"
                                className={BtnClsNames}
                                style={AuthBtnsStyle.sign_up}
                                onClick={() => navigate('/auth/signup')}
                            >
                                Sign Up
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}